module.exports = __webpack_public_path__ + "images/emoji/u5272.26df789dc1afb05a3ffb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u5272.png
// module id = 7KjD
// module chunks = 24